import { IAbsenceGroup } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";
import { PresenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { ErrorCode } from "src/utils/Company/Absences/getImportErrorMessage";
import { SkippedRowReason } from "src/utils/Company/Absences/getImportSkippedRowReason";

export enum ImportType {
  EMPLOYEE_CALENDAR_CONFIGURATION = "EMPLOYEE_CALENDAR_CONFIGURATION",
  EMPLOYEE_ABSENCE_CONFIGURATION = "EMPLOYEE_ABSENCE_CONFIGURATION",
  ABSENCE_REQUESTS = "ABSENCE_REQUESTS",
}

export enum ExportType {
  CALENDARS = "CALENDARS",
  PATTERNS = "PATTERNS",
}

export enum CalendarNameFilter {
  ALL = "ALL",
  NONE = "NONE",
}

export enum ExportMediaType {
  XLSX = "XLSX",
  CSV = "CSV",
}

export enum BalanceActions {
  ADD = "ADD",
  REMOVE = "REMOVE",
}

export enum ExportImportStatus {
  CREATED = "CREATED",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export enum ErrorType {
  UNPARSEABLE_FILE = "UNPARSEABLE_FILE",
  ROW_ERRORS = "ROW_ERRORS",
}
export interface IEmployeeRecord extends IEmployeeDetails {
  active: boolean;
  calendar: IEmployeeCalendar | null;
}

export interface IEmployeeRecordCalendars extends IEmployeeDetails {
  content: IEmployeeDetails &
    {
      calendars: IEmployeeCalendar[];
    }[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
}

export interface IEmployeeCalendar {
  calendarId: string;
  name: string;
  year: string;
  isClearable: boolean;
}

export interface IEmployeeRecords {
  content: IEmployeeRecord[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
}

export interface IPatternAssignment {
  absenceTypeId: string;
  patternId: string;
}
export interface IEmployeePatternAssignments {
  patternAssignments: IPatternAssignment[];
}

export interface IEmployeeAssignments {
  calendars: IEmployeeCalendar[];
  patterns: IPatternAssignment[];
}

export interface IEmployeeAssignmentsDTO {
  calendars: {
    [key: string]: string | null;
  };
  patterns: {
    [key: string]: string | null;
  };
}

export interface IOption {
  id: string;
  label: string;
}

export interface IEmployeeBalanceStatus {
  days: number;
  hours: number;
}

export interface IEmployeeBalance {
  confirmedPastUsedTimeAmount: IEmployeeBalanceStatus | null;
  grantedTimeAmount: IEmployeeBalanceStatus | null;
  reservedTimeAmount: IEmployeeBalanceStatus | null;
  overdueAvailableTimeAmount: IEmployeeBalanceStatus | null;
  totalAvailableTimeAmount: IEmployeeBalanceStatus | null;
}

export interface IAbsenceTypeInfo {
  absenceGroupId: string;
  active: boolean;
  description?: string;
  id: string;
  isMain: boolean;
  name: string;
  parentAbsenceTypeId: string | null;
  presenceType: PresenceType;
}

export interface IBalanceDetails {
  absenceTypeInfo: IAbsenceTypeInfo;
  status: IEmployeeBalance;
}

export interface IEmployeeBalances {
  absenceGroupInfos: IAbsenceGroup[];
  balanceDetails: IBalanceDetails[];
}

export interface IAbsenceTypeBalances {
  balanceStatuses: {
    billingCycle: string;
    overdueAvailableTimeAmount: IEmployeeBalanceStatus;
    totalAvailableTimeAmount: IEmployeeBalanceStatus;
  }[];
}

export interface IAbsenceType {
  id: string;
  name: string;
  description?: string;
  color: string;
  presenceType: PresenceType;
  status: IEmployeeBalance;
  absenceTypes?: IAbsenceType[];
  active: boolean;
  parentName?: string;
}

export interface IExportDTO {
  exportMediaType: ExportMediaType;
  exportType: ExportType;
  companyId: string;
  isActive: boolean | null;
  years?: string[];
}

export interface IExportData {
  exportId: string;
  status: ExportImportStatus;
  companyId: string;
  exportType: ExportType;
  location: string;
}

export interface IImportRowErrors {
  columns: { name: string }[];
  errorCode: ErrorCode;
}

export interface IImportErrors {
  errors: ErrorType[];
  rowErrors: IImportRowErrors;
}

export interface ISkippedRow {
  number: number;
  reason: SkippedRowReason;
}

export interface IImportData {
  exportId: string;
  companyId: string;
  requester: string;
  importType: ImportType;
  status: ExportImportStatus;
  errors: ErrorType[];
  rowErrors: IImportRowErrors;
  skippedRows: ISkippedRow[];
}
